import React, { Fragment, useState, useEffect } from "react";
import { Box, makeStyles } from "@material-ui/core";
import imageCamera from "../images/download-button.png";
import FindPictureButton from "./FincPictureButton";
import TakePictureButton from "./TakePictureButton";

import Theme, { useStyles } from "./Theme.js";

const UploadPhoto = (props) => {
  const [value, setValue] = useState(imageCamera);
  const classes = useStyles();

  useEffect(() => {
    // Quand le composant se charge, bloque la possibilité de passer sans répondre
    props.setAuthorization(true);
    let newResult = props.result;
    newResult["photo"] = "";
    props.setResult(newResult);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (picture) => {
    // Set la value du state du composant local pour rendu graphique
    const newPhoto = URL.createObjectURL(picture);
    setValue(newPhoto);
    // Set la value du state du composant parent
    let newResult = props.result;
    newResult["photo"] = picture;
    props.setResult(newResult);
  };

  return (
    <Fragment>
      <Box
        style={{
          textAlign: "center",
          margin: "0 50px 20px",
          background: "white",
          padding: 20,
          borderRadius: 10,
        }}
      >
        <img
          src={value}
          alt="en attente d'upload"
          className={classes.photo}
        ></img>
      </Box>
      <Box className={"suivantprecedent " + classes.boxButton}>
        <TakePictureButton handleChange={handleChange} />
        <FindPictureButton handleChange={handleChange} />
      </Box>
    </Fragment>
  );
};

export default UploadPhoto;
